const LETTER_COUNT = 26;
const BASE_36 = 36;
const DIFFERENCE = 9;
const INITIAL_COUNT = 0;
const NORMALIZE_ZERO_BASED_INDEX = 1;
/**
 * Calculates column index from excel column letters
 * @param letters
 * @returns {*|null}
 */
export const calculateColumnIndex = letters => {
  const index =
    letters
      ?.split('')
      .reduce((r, a) => r * LETTER_COUNT + parseInt(a, BASE_36) - DIFFERENCE, INITIAL_COUNT) ||
    null;

  return index ? index - NORMALIZE_ZERO_BASED_INDEX : null;
};
